import api from '../../../utils/api'
import { IReportProps } from '../interfaces'



export const getReportById = async (id: number, lis: boolean): Promise<IReportProps> => {
    return await api.get(`report/${id}?lis=${lis}`).then(resp => resp.data)
}

export const postReportEditionRequest = async(report:any) => {
    return await api.post('report/create-edit-request', report)
}